import React, { FC, ReactElement, RefObject, useRef, useState } from 'react'
import { ButtonBase, Popper, Zoom } from '@material-ui/core'
import Icon, { IconName } from '../../../../React/Common/Components/Icon'
import { EMPTY_STRING } from '../../../../NonReact/constants/Common'
import { ReactState } from '../../../../React/Common/Types/Types'
import { isVarNotEmpty } from '../../../../NonReact/utils/GlobalFunctions'

type Props = {
    iconName: IconName
    label?: string
    onClick: (event?: React.MouseEvent) => void
    onMiddleClick?: (event?: React.MouseEvent) => void
    type?: 'button' | 'submit' | 'reset'
    title?: string
    id?: string
    className?: string
    tooltip?: string
    topRightAdornment?: ReactElement
    popperClassNames?: string
}

export const IconButtonWithLabel: FC<Props> = ({
    iconName,
    label,
    onClick,
    onMiddleClick,
    title,
    type,
    id,
    className,
    tooltip,
    topRightAdornment,
    popperClassNames
}: Props): ReactElement => {
    const anchorEl: RefObject<HTMLButtonElement> = useRef(null)

    const [isTooltipOpen, setIsTooltipOpen]: ReactState<boolean> = useState<boolean>(false)

    return (
        <div
            className='icon-button-with-label-container'
            onMouseEnter={(): void => setIsTooltipOpen(true)}
            onMouseLeave={(): void => setIsTooltipOpen(false)}
        >
            <ButtonBase
                id={id}
                ref={anchorEl}
                title={title}
                onClick={onClick}
                onAuxClick={onMiddleClick}
                type={type ?? 'button'}
                className={`icon-button-with-label ${className ?? EMPTY_STRING}`}
            >
                <Icon className='ibwl-icon' iconName={iconName} />
                {label ? <span className='ibwl-label'>{label}</span> : <></>}
                {tooltip ? (
                    <Popper
                        className={`ibwl-tooltip-container ${popperClassNames ?? EMPTY_STRING}`}
                        open={isTooltipOpen}
                        anchorEl={anchorEl.current}
                        placement='right'
                        transition
                    >
                        {({ TransitionProps }): ReactElement => (
                            <Zoom {...TransitionProps} timeout={200}>
                                <div className='ibwl-tooltip'>{tooltip}</div>
                            </Zoom>
                        )}
                    </Popper>
                ) : (
                    <></>
                )}
            </ButtonBase>
            {isVarNotEmpty(topRightAdornment) ? <div className='top-right-adornment'>{topRightAdornment}</div> : <></>}
        </div>
    )
}
